import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Popup from '../../common/Popup/Popup';
import AppTable from '../../common/AppTable/AppTable';
import { taskTableColumns } from './TaskTableColumns';
import AddEditRow from './AddEditRow';
import { fetchTasksByUserId } from '../../redux/taskSlice';
import { fetchUsers } from '../../redux/userSlice';
import { showSnackbar } from '../../redux/snackbarSlice';
import { Button } from '../../common/Buttons';
import Loader from '../../common/Loader';
import HeadingWithDescription from '../../common/Others/HeadingWithDescription';
import { handleUpdateTask, handleDeleteTask } from './Uitlities';
import { getLoggedInUserInfo } from '../../util/AppUtils';
import Snackbar from '../../common/Snackbar';

const DisableUserTaskPopup = ({ closeModal, userId, onContinue }) => {
  const dispatch = useDispatch();
  const { tasks, loading, taskReference } = useSelector((state) => state.task);
  const { users } = useSelector((state) => state.users);
  const { task_reference } = taskReference || {};
  const reassign_persmision = getLoggedInUserInfo()?.permission_to_edit?.Reassign === true;

  const [editTask, setEditTask] = useState(null);
  const [previusTaskInfo, setPreviusTaskInfo] = useState(null);

  useEffect(() => {
    if (userId) {
      dispatch(fetchTasksByUserId({ user_id: userId }));
    }
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(fetchUsers({ limit: 100000, offset: 0 }));
  }, [dispatch]);

  const snackbar = (message, type) => {
    dispatch(showSnackbar({ type: type, message: message }));
  };

  const updateTaskInfo = async () => {
    await handleUpdateTask({
      editTask,
      previusTaskInfo,
      reassign_persmision,
      users,
      dispatch,
      snackbar,
      onSuccess: async () => {
        await dispatch(fetchTasksByUserId({ user_id: userId }));
      },
      setEditTask
    });
  };

  const delTask = async (task_id, task_name) => {
    await handleDeleteTask({
      task_id,
      task_name,
      dispatch,
      snackbar,
      onSuccess: async () => {
        await dispatch(fetchTasksByUserId({ user_id: userId }));
      },
      setEditTask
    });
  };

  const getLoadingMessage = () => {
    if (editTask) return "Updating task...";
    return "Loading tasks...";
  };

  const columns = taskTableColumns.map(d => ({ ...d, sort: false }));
  const allTasks = Array.isArray(tasks) 
    ? tasks.filter(task => task.status !== "COMPLETED" && task.status !== "CANCELLED")
    : [];

  return (
    <Popup closeModal={closeModal} title="" 
    headerStyle={{borderBottom: '1px solid #e0e0e0',paddingBottom: '10px'}}
    customHeading={<><p style={{textAlign:"left",margin:"0px",fontSize:"20px",paddingLeft:"0px",color:"red"}}>User {users.find(user => user.id === userId)?.name} will be Disabled</p></>}
    >
      <div>
        <HeadingWithDescription
          heading="Assigned and Owned Tasks"
          description="Before disabling the user, the following tasks should be reassigned tasks to another user."
        />

        {/* Table */}
        {loading && <Loader text={getLoadingMessage()} />}
        <AppTable
          columnsData={columns}
          showSearchInput={false}
          usingInPopup={true}
          paginate={false}
          showScroll={true}
        >
          {allTasks.map((task) => {
            let key = task.task_id;
            return editTask && editTask.task_id === task.task_id ? (
              <AddEditRow
                key={key}
                taskInfo={task}
                handleAddEditRow={updateTaskInfo}
                inputState={setEditTask}
                action="edit"
                reference={task_reference}
                closePopup={closeModal}
                setPreviusTaskInfo={setPreviusTaskInfo}
                reassign_persmision={reassign_persmision}
              />
            ) : (
              <AddEditRow
                key={key}
                taskInfo={task}
                inputState={setEditTask}
                delTask={delTask}
                setPreviusTaskInfo={setPreviusTaskInfo}
                reference={task_reference}
                closePopup={closeModal}
                reassign_persmision={reassign_persmision}
                showUserHighlight={true}
                hilightedUserId={userId}
              />
            );
          })}
        </AppTable>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '10px',
          marginTop: '0px',
          paddingTop: '5px',
          paddingRight: '15px',
          paddingBottom: '15px',
          borderTop: '1px solid #e0e0e0'
        }}>
          <Button
            variant="secondary"
            onClick={() => closeModal(false)}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              if(allTasks.length === 0) {
                Snackbar("No tasks to reassign", "error");
                return; 
              }
              if (onContinue) {
                onContinue();
              }
              closeModal(false);
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </Popup>
  );
};

export default DisableUserTaskPopup;


